var scope_0 = require('/Users/mnouayti/HrFlow/open-jobboard2.0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/65adca0f93f50c8b7a1580468a16e86c.js').default;
var scope_1 = require('/Users/mnouayti/HrFlow/open-jobboard2.0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    